import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledDescriptiveLinkBlock } from "segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/descriptive-link-block/descriptive-link-block.scss";
const DescriptiveLinkBlock = ({ Icon, link, title, description, TitleIcon, onClick })=>/*#__PURE__*/ _jsxs(StyledDescriptiveLinkBlock, {
        onClick: onClick,
        className: "descriptive-link-block",
        href: link,
        children: [
            /*#__PURE__*/ _jsx(Icon, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "details",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "title",
                        children: [
                            title,
                            TitleIcon && /*#__PURE__*/ _jsx(TitleIcon, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "description",
                        children: description
                    })
                ]
            })
        ]
    });
export default DescriptiveLinkBlock;
